import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

interface PartExchangePanelProps {
  [key: string]: any;
}

export default function PartExchangePanel(props: PartExchangePanelProps) {
    return (
        <>
        <div className="l-node-frontpage__block-small sell">
            <div className="block-inner">
                <div className="block-header">
                <h2>{props['px-header']}</h2>
                <p>{props['px-text']}</p>
                </div>
                <div className="block-form">
                <p><strong>{props['px-reg-text']}</strong></p>
                <a className="fields-wrap" data-bs-toggle="modal" data-bs-target="#partExchangePopup">
                    <div className="vrm-input">ENTER REG</div>
                    <button>{props['part-exchange-cta-button-text']} <FontAwesomeIcon icon={faArrowRight} className="fa-fw" /></button>
                </a>
                </div>
            </div>
        </div>

 
        <div className="modal fade" id="partExchangePopup">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <h2>Part Exchange</h2>
                    </div>
                </div>
            </div>
        </div>


        </>
    );
}